import React from "react";
import firebase from "firebase";

var config = {
  apiKey: "AIzaSyAedrjSRDcJ3MtWq4vAd30Uys5hdT3WQds",
  authDomain: "drawonapp.firebaseapp.com",
  databaseURL: "https://drawonapp.firebaseio.com",
  projectId: "drawonapp",
  storageBucket: "drawonapp.appspot.com",
  messagingSenderId: "29199469210"
};

const app = firebase.initializeApp(config);

const database = app.database();

const FirebaseContext = React.createContext(app);
const {
  Provider: FirebaseProvider,
  Consumer: FirebaseConsumer
} = FirebaseContext;

const DatabaseContext = React.createContext(database);
const {
  Provider: DatabaseProvider,
  Consumer: DatabaseConsumer
} = DatabaseContext;

export {
  app as firebase,
  FirebaseContext,
  FirebaseProvider,
  FirebaseConsumer,
  DatabaseContext,
  DatabaseProvider,
  DatabaseConsumer
};
